export const cancelOrderFromUser = (message, reducers, data, connection) => {
  const { orderId, placeId, userId, pointId } = message.payload;
  const { eventsDispatch } = reducers;
  eventsDispatch({ type: 'ORDER_CANCEL', payload: { orderId, placeId, userId, pointId } });
}